import {Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CompassService} from '../../compass.service';
import {map, take, tap} from 'rxjs/operators';
import {AutoUnsubscribeTakeUntilClass} from 'shared/models';
import {finalize} from "rxjs";


@Component({
    selector: 'app-compass',
    templateUrl: './compass.component.html',
})
export class CompassComponent extends AutoUnsubscribeTakeUntilClass {

    private compassService = inject(CompassService);
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);

    private themesAreLoading = true;
    private exploreDataIsLoading = true;
    private compassHelperIsLoading = true;


    public themes$ = this.compassService.loadThemes({range: 2, filter: {promoted: '1'}})
        .pipe(
            take(1),
            tap(() => this.themesAreLoading = true),
            finalize(() => this.themesAreLoading = false));
    public themesPromoted$ = this.themes$.pipe(map(themes => themes.filter(theme => theme.get('promoted') === '1')));
    public exploreData$ = this.compassService.loadExploreData()
        .pipe(
            take(1),
            tap(() => this.exploreDataIsLoading = true),
            finalize(() => this.exploreDataIsLoading = false));
    public compassHelper$ = this.compassService.fetchCompassHomepage()
        .pipe(
            take(1),
            tap(() => this.compassHelperIsLoading = true),
            finalize(() => this.compassHelperIsLoading = false));

    public isSearchFormVisible = this.compassService.isSearchActive;

    public isLoading() {
        return this.compassHelperIsLoading || this.exploreDataIsLoading || this.themesAreLoading;
    }

    public getQueryParams() {
        const qp = {
            fromUrl: this.router.url.split('?')[0] ,
        }

        if (Object.keys(this.activatedRoute.snapshot.queryParams).length) {
            qp['fromQueryParams'] = JSON.stringify(this.activatedRoute.snapshot.queryParams);
        }

        return qp;
    }

    public onSearchFormDone($event: string): void {
        this.router.navigate(['search', $event], { relativeTo: this.activatedRoute});
    }
}

